import { render } from "./XGroupMenu.vue?vue&type=template&id=327f0e66"
import script from "./XGroupMenu.vue?vue&type=script&lang=js"
export * from "./XGroupMenu.vue?vue&type=script&lang=js"

import "./XGroupMenu.vue?vue&type=style&index=0&id=327f0e66&lang=less"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.33_webpack@5.93.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__